<template>
    <div>
      <div class="right-item-content">
        <div class="right-item-view" v-for="item in notices" :key="item.id" @click="handleClick(item)">
          <div>{{item.title}}</div>
          <div style="font-family: 12px;">{{item.createTime}}</div>
        </div>
      </div>
    </div>
  </template>

  <script>
import http from "@/utils/http/axios";

  export default {
    data() {
      return {
        notices: []
      }
    },
    mounted() {
      this.getNotices()
    },
    methods: {
      getNotices() {
        http.get('/article/notice/list', {pageSize: 3, pageNum: 1}).then(res => {
          if(res.code === 200) {
            this.notices = res.rows
          }
        })
      },
      handleClick(item) {
        item.type = "网站公告"
        this.$router.push({
          path: '/newsdetail',
          query: { news: item }
        })
      }
    }
  };
  </script>

  <style lang="less" scoped>
  .right-item-content {
    margin-top: 10px;
    padding: 20px;
    color: #000000e0;
    font-size: 18px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 8px;
    .right-item-view {
      height: 70px;
      border-bottom: 2px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      color: #000000e0
    }
  }
  </style>
